import type { ParametreGeneralEntite } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type { DateRecupMarco } from '../../components/MarcheMarco/MarcheMarcoTable';
import type StatutMarcheMarco from '../../constants/marcheMarco/statutMarcheMarco';
import type MarcheMarco from '../../interfaces/marcheMarco/marcheMarco';

const getMarchesMarco = async (identifiantEntite: number) =>
	request.get<unknown, TemplateRequestGet<MarcheMarco>>(
		`/api/finances/comptabilite/marches/marchesMarco?identifiantEntite=${identifiantEntite}&all=true`,
	);

export const updateMarcheMarcoStatut = async (
	marche: MarcheMarco,
	statut: StatutMarcheMarco,
) =>
	request.put<Partial<MarcheMarco>, MarcheMarco>(
		`/api/finances/comptabilite/marches/marchesMarco/${marche.identifiant}`,
		{ statut },
	);

export const getPgEntites = async () =>
	request.get<unknown, TemplateRequestGet<ParametreGeneralEntite>>(
		'/api/finances/comptabilite/parametrescomptabilites/entites?withEntite=true&withMarchesMarco=true',
	);

export const fetchContracts = async () =>
	request.get<unknown, TemplateRequestGet<MarcheMarco>>(
		'/api/finances/comptabilite/marches/marchesMarco/fetchContracts',
	);

export const getDateRecupMarco = async () =>
	request.get<unknown, TemplateRequestGet<DateRecupMarco>>(
		'/api/finances/comptabilite/parametrescomptabilites/paramTechnique?libelle=DATE_RECUP_MARCO',
	);

export const createMarcheFromMarcheMarco = async (marche: MarcheMarco) =>
	request.post<MarcheMarco, MarcheMarco>(
		`/api/finances/comptabilite/marches/createFromMarcheMarco/${marche.identifiant}`,
		marche,
	);

export default getMarchesMarco;
